import { useEffect, useMemo, useState, useRef } from "react";
import useAuthAdmin from "../Admin/useAuthAdmin";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { handleApiError } from "../../utils/handleApiError";

export default function useEmployeeDocumentPersonal() {
  const [documents, setDocuments] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0); // 🆕 Key to trigger refresh
  const { adminSession, logout } = useAuthAdmin();
  const navigate = useNavigate();
  const { id } = useParams();

  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${adminSession}`,
    }),
    [adminSession]
  );

  // Use ref to store latest values to avoid dependency issues
  const headersRef = useRef(headers);
  const idRef = useRef(id);
  const logoutRef = useRef(logout);
  const navigateRef = useRef(navigate);

  // Update refs when values change
  useEffect(() => {
    headersRef.current = headers;
    idRef.current = id;
    logoutRef.current = logout;
    navigateRef.current = navigate;
  }, [headers, id, logout, navigate]);

  useEffect(() => {
    if (!idRef.current) return;

    const fetchDocuments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/employees/documents/${idRef.current}/all`,
          { headers: headersRef.current }
        );
        const fetchedDocuments = response.data.data;
        setDocuments(fetchedDocuments);
        console.log("Documents (creditcheck):", fetchedDocuments);
      } catch (error) {
        handleApiError(error, logoutRef.current, navigateRef.current);
      }
    };

    fetchDocuments();
  }, [refreshKey, id]);

  // 🆕 Call this to trigger a refetch
  const refetch = () => setRefreshKey((prev) => prev + 1);

  return { documents, refetch };
}
